export default {
    'widgets.wallet-account-view.card.send': 'Send',
    'widgets.wallet-account-view.card.receive': 'Receive',
    'widgets.wallet-account-view.tokens-list.title': 'Your tokens',
    'widgets.wallet-account-view.card.more.copy': 'Copy Address',
    'widgets.wallet-account-view.card.more.view': 'View on Explorer',
    'widgets.wallet-account-view.card.more.switch': 'Switch Wallet',
    'widgets.wallet-account-view.card.more.disconnect': 'Disconnect Wallet',
};
//# sourceMappingURL=en.js.map